import React from 'react'
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useEffect, useState} from 'react'
import {AbilityContext} from '../../../../../app/modules/auth/core/AbilityContext'
import {useAbility} from '@casl/react'
import {getSidebarMenus} from '../../../../../app/modules/auth/core/_requests'
import useAxiosPrivate from '../../../../../app/libs/useAxiosPrivate'

const SidebarMenuMain = () => {
  const intl = useIntl()
  const axiosPrivate = useAxiosPrivate()
  // Use useAbility for reactive updates
  const ability = useAbility(AbilityContext)
  const [sidebarMenuConfig, setSidebarMenuConfig] = useState<any[]>([])

  useEffect(() => {
    getSidebarMenus(axiosPrivate)
      .then((res) => {
        setSidebarMenuConfig(res.data.data)
      })
      .catch((err) => {
        console.error('Failed to load sidebar menus', err)
      })
  }, [])

  const canAccess = (to?: string) => {
    // If 'to' is undefined/null, it's a container/section which visibility is determined by children
    if (to === undefined || to === null) return true
    // Check CASL ability using Title
    return ability.can('read', to)
  }

  return (
    <>
      {sidebarMenuConfig.map((menu) => {
        if (menu.type === 'item') {
          return (
            canAccess(menu.title) && (
              <SidebarMenuItem
                key={menu.to}
                to={menu.to!}
                icon={menu.icon}
                title={menu.titleId ? intl.formatMessage({id: menu.titleId}) : menu.title}
                fontIcon={menu.fontIcon}
              />
            )
          )
        }

        if (menu.type === 'section') {
          const accessibleChildren = menu.children?.filter((child) => {
            if (child.type === 'submenu') {
              return child.children?.some((sub) => canAccess(sub.title))
            }
            return canAccess(child.title)
          })
          if (!accessibleChildren?.length) return null

          return (
            <React.Fragment key={menu.label}>
              <div className='menu-item'>
                <div className='menu-content pt-8 pb-2'>
                  <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                    {menu.label}
                  </span>
                </div>
              </div>

              {accessibleChildren.map((child) => {
                if (child.type === 'item') {
                  return (
                    <SidebarMenuItem
                      key={child.to}
                      to={child.to!}
                      icon={child.icon}
                      title={child.titleId ? intl.formatMessage({id: child.titleId}) : child.title}
                    />
                  )
                }

                if (child.type === 'submenu') {
                  const subChildren = child.children?.filter((sub) => canAccess(sub.title))
                  if (!subChildren?.length) return null

                  return (
                    <SidebarMenuItemWithSub
                      key={child.to}
                      to={child.to!}
                      icon={child.icon}
                      title={child.titleId ? intl.formatMessage({id: child.titleId}) : child.title}
                    >
                      {subChildren.map((sub) => (
                        <SidebarMenuItem
                          key={sub.to}
                          to={sub.to!}
                          title={sub.titleId ? intl.formatMessage({id: sub.titleId}) : sub.title}
                          hasBullet
                        />
                      ))}
                    </SidebarMenuItemWithSub>
                  )
                }

                return null
              })}
            </React.Fragment>
          )
        }

        return null
      })}
    </>
  )
}

export {SidebarMenuMain}
